import { React, useState, useEffect } from "react";
import styles from "./TimePicker.module.css";
import { ReactComponent as ClockIcon } from "./Clock_Icon.svg";
import PropTypes from "prop-types";

/**
 * Interactive component that allows user to type in and pick a time
 * Returns two values, a string for numeric time, and a string for a.m./p.m.
 * See stories for example.
 */

export function TimePicker({ timeString, onChange, readOnly = false  }) {
  const [amPm, setAmPm] = useState("a.m.");
  const [valueString, setValueString] = useState("");

  useEffect(() => {
    setValueString(timeString.replace(/[a-zA-Z\.]+/g, "").trim());

    var str = timeString.replace(/[0-9]|:/g, "").trim();
    if (str.length > 1) {
      setAmPm(timeString.replace(/[0-9]|:/g, "").trim());
    }


  }, [timeString]);


  const onClick = () => {
    if (amPm === "a.m.") {
      setAmPm("p.m.");
      onChange(valueString + " p.m.");
    } else {
      setAmPm("a.m.");
      onChange(valueString + " a.m.");
    }
  };


  function handleChange(v){
    setValueString(v);
    onChange(v + " " + amPm);

    console.log("happening");
  }

  return (
    <div className={styles.container}>
      <input
        readOnly={readOnly}
        type="text"
        value={valueString}
        onChange={(e) => handleChange(e.target.value)}
        
        className={styles.input}
        placeholder={"00:00"}
      ></input>
      <div
        className={
          valueString.length < 5 ? styles.amPmSmallerLeft : styles.amPm
        }
      >
        {amPm}
      </div>
      <div className={styles.icon} onClick={()=> {
          if(!readOnly){
            onClick()
          }
        }}>
        <ClockIcon />
      </div>
    </div>
  );
}

TimePicker.propTypes = {
  // current date being displayed
  timeString: PropTypes.string,

  // function used to set date
  onChange: PropTypes.func,
};
